import { render, staticRenderFns } from "./InstallmentsDescriptionBox.vue?vue&type=template&id=33c75fc4"
import script from "./InstallmentsDescriptionBox.vue?vue&type=script&lang=js"
export * from "./InstallmentsDescriptionBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports